<template>
  <div class="detalle-operacion-panel">
    <DxTabPanel height="95%" tabs-position="top" icon-position="left">
      <DxItem :key="1" :title="tituloTab1" class="tab-item" :disabled="false" icon="fa-regular fa-user">
        <operaciones-agua-resumen-tab-titular :model="model"></operaciones-agua-resumen-tab-titular> 
      </DxItem>
      <DxItem :key="2" :title="tituloTab2" class="tab-item" :disabled="false" icon="fa-regular fa-map-marker-alt">
        <operaciones-agua-resumen-tab-suministro :model="model"></operaciones-agua-resumen-tab-suministro>
      </DxItem>
      <DxItem :key="3" :title="tituloTab3" class="tab-item" :disabled="false" icon="fa-regular fa-file-invoice">
        <operaciones-agua-resumen-tab-facturacion :model="model"></operaciones-agua-resumen-tab-facturacion>  
      </DxItem>
      <DxItem :key="4" :title="tituloTab4" class="tab-item" :disabled="false" icon="fa-regular fa-folder-open">
        <operaciones-agua-resumen-tab-documentos :documentos="model?.Documentos!" :idOperacion="model?.Id" 
          :estructuraDocumental="estructuraDocumental!" @documento-subido="onDocumentoSubido"/> 
      </DxItem>
      <DxItem :key="5" :title="tituloTab5" class="tab-item" :disabled="false" icon="fa-regular fa-comment-dots">
        <operaciones-agua-resumen-tab-observaciones :model="model"/>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import OperacionesAguaResumenTabDocumentos from '@/components/operaciones-agua/OperacionesAguaResumenTabDocumentos.vue';
import OperacionesAguaResumenTabTitular from '@/components/operaciones-agua/OperacionesAguaResumenTabTitular.vue';
import OperacionesAguaResumenTabSuministro from '@/components/operaciones-agua/OperacionesAguaResumenTabSuministro.vue';
import OperacionesAguaResumenTabFacturacion from '@/components/operaciones-agua/OperacionesAguaResumenTabFacturacion.vue';
import OperacionesAguaResumenTabObservaciones from '@/components/operaciones-agua/OperacionesAguaResumenTabObservaciones.vue';
import { computed } from 'vue';
import { type DetailOperacionAguaModel, type EstructuraDocumentalOperacionModel } from '@/.shared/.api';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import { useIntl } from '@/.shared/services/i18n/i18nservice';

const intl = useIntl();

defineProps({
  model: Object as () => DetailOperacionAguaModel,
  estructuraDocumental: Object as () => EstructuraDocumentalOperacionModel[]
});

const emit = defineEmits(['documentoSubido']);

const tituloTab1 = computed(() => `${intl.i18n.t('operaciones.form.datos_del_titular')}`);
const tituloTab2 = computed(() => `${intl.i18n.t('operaciones.form.direccion_datos_suministro')}`);
const tituloTab3 = computed(() => `${intl.i18n.t('operaciones.form.datos_facturacion')}`);
const tituloTab4 = computed(() => `${intl.i18n.t('operaciones.form.documentacion')}`);
const tituloTab5 = computed(() => `${intl.i18n.t('operaciones.form.observaciones')}`);

const onDocumentoSubido = () => {
  emit('documentoSubido');
};

</script>